import createIcon from '@/lib/create-icon'

const TableTennisIcon = createIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 46 46'
    fill='none'
  >
    <path
      fill='none'
      d='M11 14L28 32'
      stroke='url(#paint0_linear_5298_2305)'
      strokeWidth='2.8'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M11 14L28 32'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.8'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M11 14L28 32'
      stroke='url(#paint1_radial_5298_2305)'
      strokeOpacity='0.6'
      strokeWidth='2.8'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M4.85404 32.3269C7.97588 30.3646 12.7483 27.4281 13.4507 24.4482C13.6691 23.5214 13.1782 22.6226 12.7543 21.7698C10.7038 17.6448 10.6576 12.8418 13.706 9.79726C19.022 4.48801 30.4343 1.36643 36.0373 6.96146C41.6338 12.55 38.5139 23.9521 33.1974 29.2609C30.1485 32.3055 25.3404 32.2608 21.2093 30.2127C20.355 29.7894 19.455 29.2989 18.5266 29.5171C15.5423 30.2185 12.6007 34.983 10.6357 38.1003C8.5006 41.4874 1.61029 34.3656 4.85404 32.3269Z'
      stroke='url(#paint2_linear_5298_2305)'
      strokeWidth='2.8'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M4.85404 32.3269C7.97588 30.3646 12.7483 27.4281 13.4507 24.4482C13.6691 23.5214 13.1782 22.6226 12.7543 21.7698C10.7038 17.6448 10.6576 12.8418 13.706 9.79726C19.022 4.48801 30.4343 1.36643 36.0373 6.96146C41.6338 12.55 38.5139 23.9521 33.1974 29.2609C30.1485 32.3055 25.3404 32.2608 21.2093 30.2127C20.355 29.7894 19.455 29.2989 18.5266 29.5171C15.5423 30.2185 12.6007 34.983 10.6357 38.1003C8.5006 41.4874 1.61029 34.3656 4.85404 32.3269Z'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.8'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M4.85404 32.3269C7.97588 30.3646 12.7483 27.4281 13.4507 24.4482C13.6691 23.5214 13.1782 22.6226 12.7543 21.7698C10.7038 17.6448 10.6576 12.8418 13.706 9.79726C19.022 4.48801 30.4343 1.36643 36.0373 6.96146C41.6338 12.55 38.5139 23.9521 33.1974 29.2609C30.1485 32.3055 25.3404 32.2608 21.2093 30.2127C20.355 29.7894 19.455 29.2989 18.5266 29.5171C15.5423 30.2185 12.6007 34.983 10.6357 38.1003C8.5006 41.4874 1.61029 34.3656 4.85404 32.3269Z'
      stroke='url(#paint3_radial_5298_2305)'
      strokeOpacity='0.6'
      strokeWidth='2.8'
      strokeLinejoin='round'
    />
    <circle
      cx='38'
      cy='38'
      r='3.1'
      stroke='url(#paint4_linear_5298_2305)'
      strokeWidth='1.8'
      fill='none'
    />
    <circle
      cx='38'
      cy='38'
      r='3.1'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='1.8'
      fill='none'
    />
    <circle
      cx='38'
      cy='38'
      r='3.1'
      stroke='url(#paint5_radial_5298_2305)'
      strokeOpacity='0.6'
      strokeWidth='1.8'
      fill='none'
    />
    <defs>
      <linearGradient
        id='paint0_linear_5298_2305'
        x1='11'
        y1='14'
        x2='31.1415'
        y2='27.2101'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_5298_2305'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(19.5 32) scale(8.5 9.16627)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint2_linear_5298_2305'
        x1='4'
        y1='4'
        x2='44.0104'
        y2='31.785'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint3_radial_5298_2305'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(21.5 39) scale(17.5 17.8233)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint4_linear_5298_2305'
        x1='34'
        y1='34'
        x2='43.1452'
        y2='40.3509'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint5_radial_5298_2305'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(38 42) scale(4 4.0739)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
    </defs>
  </svg>,
  'TableTennisIcon'
)

export default TableTennisIcon
